import React from "react";
import {
  Box,
  Typography,
  Modal,
  IconButton,
  Stack
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import inviteSvg from "../../../assets/svg/invite.svg";

interface InvitationSuccessModalProps {
  open: boolean;
  onClose: () => void;
  email?: string;
}

const InvitationSuccessModal: React.FC<InvitationSuccessModalProps> = ({
  open,
  onClose,
  email = ""
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90vw", sm: 520 },
          bgcolor: "#fff",
          borderRadius: 4,
          p: { xs: 3, sm: 4 },
          outline: "none"
        }}
      >
        {/* Close Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ color: "#212121", p: 0 }}
          >
            <CloseIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </Box>

        {/* Icon */}
        <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 3 }}>
          <img
            src={inviteSvg}
            alt="Invite"
            style={{ width: 80, height: 80 }}
          />
        </Box>

        {/* Success Message */}
        <Stack spacing={2} sx={{ textAlign: "left" }}>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 700,
              fontSize: { xs: 22, sm: 18 },
              color: "#212121",
              lineHeight: 1.2
            }}
          >
            Invite Sent Successfully!
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: 14,
              color: "#374151",
              lineHeight: 1.6,
              letterSpacing: "-0.3%"
            }}
          >
            Your invite has been sent to Organisation Admin on their Email ID. You will receive an update on the status of your invite.
          </Typography>
        </Stack>
      </Box>
    </Modal>
  );
};

export default InvitationSuccessModal;
